import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class Observable {
    subscribe(subscriber) {
        this.observers.push(subscriber);
    }
    unsubscribe(id) {
        this.observers = this.observers.filter((obs)=>obs.id !== id);
    }
    async notify(data) {
        await Promise.allSettled(this.observers.map((observer)=>observer.callback(data)));
    }
    constructor(){
        _define_property(this, "observers", void 0);
        this.observers = [];
    }
}
